import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import {
  getCancerList,
  getICDList,
  addCancerTemplateData, getCancerTemplateData,
  getCancerTemplateDataName
} from "../../core/services/api/patientDiagnosisService";
import defaultSurveyConfig from "../../pages/RMO/components/cancerTemplateForm/template";
import InputField from "../InputField";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import Toast from "../../components/Toast";
import {
  cancerAllContent,
  cancerAmlContent,
  cancerAmlContentApl,
  cancerBladderContent,
  cancerProstateContent,
  cancerTesticularContent,
  standardResponseCriteria,
} from "./riskTables";
import "./StagingDiagnosis.scss";
import CancerTemplateComponent from "pages/RMO/components/cancerTemplate/CancerTemplate";

export default function StagingDiagnosis({
  recordDetails,
  patientDetail,
  appointmentDetails,
  isReadOnly,
  scroll
}: any) {
  const patientId = appointmentDetails?.patientId;
  const [cancerType, setCancertype] = useState([{ label: "", value: "" }]);
  let [template, setTemplate] = useState<any>({});
  let stagingDataObj = {
    relapseOrProgression: false,
    cancerType: "",
    cancerTemplateId: "",
    diagnosis: "",
    diagnosisDate: "",
    icd: "",
    id: "",
  };
  const [stagingData, setStagingData] = useState([stagingDataObj]);
  const [icdOptions, setIcdOptions] = useState<any>({});
  const [surveyData, setSurveyData] = useState<any>("");
  const [isCompleted, setIsCompleted] = useState<any>(false);
  const [isError, setIsError] = useState<any>(false);
  const [message, setMessage] = useState<any>("");
  const [concatCancerType, setConcatCancerType] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [savedStagingData, setSavedStagingData] = useState<any>();
  const [displayToast, toggleDisplayToast] = useState<any>(false)

  const [inputICDValue, setInputICDValue] = useState<any>([])
  const [inputFullICDValue, setInputFullICDValue] = useState<any>([])
  const icdRef = useRef<any>(null);

  //Plug-ins for custom UI components
  const [flag, setFlag] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [content, setContent] = useState<any>();

  const updateCallback = (data: any, survey: any) => {
    setFlag(!flag);
    // let formattedSurveyData: any = formatStagingData(survey, data)
    setSurveyData(data);
    // setTimeout(() => {
    //   getCd4Element();
    // }, 0);
  };

  useEffect(() => {
    setTimeout(() => {
      const moreInfoBtn = document.getElementById("moreInfo");
      if (moreInfoBtn) {
        moreInfoBtn.addEventListener("click", () => {
          setOpen(true);
        });
      }
      const moreInfoBtn_ALL = document.getElementById("moreInfo_ALL");
      if (moreInfoBtn_ALL) {
        moreInfoBtn_ALL.addEventListener("click", () => {
          setContent(cancerAllContent());
          setOpen(true);
        });
      }
      const moreInfoBtn_AML_Apl = document.getElementById(
        "moreInfoBtn_AML_Apl"
      );
      if (moreInfoBtn_AML_Apl) {
        moreInfoBtn_AML_Apl.addEventListener("click", () => {
          setContent(cancerAmlContentApl());
          setOpen(true);
        });
      }
      const moreInfoBtn_AML_NonAPl = document.getElementById(
        "moreInfoBtn_AML_NonAPl"
      );
      if (moreInfoBtn_AML_NonAPl) {
        moreInfoBtn_AML_NonAPl.addEventListener("click", () => {
          setContent(cancerAmlContent());
          setOpen(true);
        });
      }
      const moreInfoBtn_BladderCancer = document.getElementById(
        "moreInfo_BladderCancer"
      );
      if (moreInfoBtn_BladderCancer) {
        moreInfoBtn_BladderCancer.addEventListener("click", () => {
          setContent(cancerBladderContent());
          setOpen(true);
        });
      }
      const moreInfoBtn_ProstateCancer = document.getElementById(
        "moreInfo_ProstateCancer"
      );
      if (moreInfoBtn_ProstateCancer) {
        moreInfoBtn_ProstateCancer.addEventListener("click", () => {
          setContent(cancerProstateContent());
          setOpen(true);
        });
      }
      const moreInfoBtn_TesticularCancer = document.getElementById(
        "moreInfo_TesticularCancer"
      );
      if (moreInfoBtn_TesticularCancer) {
        moreInfoBtn_TesticularCancer.addEventListener("click", () => {
          setContent(cancerTesticularContent());
          setOpen(true);
        });
      }
      const moreInfoBtn_standardResponseCriteria = document.getElementById(
        "standard_Response_Critria"
      );
      if (moreInfoBtn_standardResponseCriteria) {
        moreInfoBtn_standardResponseCriteria.addEventListener("click", () => {
          setContent(standardResponseCriteria());
          setOpen(true);
        });
      }
    }, 2000);
  }, [flag, template, isLoading]);

  //To fetch cancer types
  useEffect(() => {
    getCancerList().then((res) => {
      const tempCancerTypes = res?.data?.map((ele: any) => {
        return { label: ele?.subType, value: ele?.id };
      });
      setCancertype(tempCancerTypes);

      if (patientId) {
        // setIsLoading(true);
        //To fetch previously saved cancer template data
        getCancerTemplateData({ patientId: patientId })
          .then((res: any) => {
            const temp = res?.diagnosis?.map((ele: any) => {
              const obj = tempCancerTypes?.find(
                (each: any) => each?.label === ele?.cancerType
              );
              return { ...ele, ...{ id: obj?.value } };
            });
            setSurveyData(res?.staging);
            setStagingData(temp);
            updateInputValues(temp);
          })
          .catch((err) => {
            setIsLoading(false);
            console.log(err);
          });
      }
    });
  }, [patientId]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     getCd4Element();
  //   }, 0);
  // }, [stagingData, template]);

  //To fetch ICD options for individual row against each cancer type selected
  useEffect(() => {
    if (stagingData.length > 0) {
      // setIsLoading(true);
      let concactCancer: any = [];
      let tempIcdOptions: any = {};
      stagingData.forEach((each: any, index: any) => {
        if (each?.cancerType) {
          concactCancer.push(each?.id);
          if (
            each?.cancerType ===
            "Pleural Mesothelioma Or Peritoneal Mesothelioma"
          ) {
            if (
              !icdOptions[`Pleural Mesothelioma or Peritoneal Mesothelioma`]
            ) {
              getICDList("Pleural mesothelioma")
                .then((data) => {
                  const resOptions = data.data.destinationEntities;
                  const res = resOptions.map((o: any) => {
                    let tempArr = o.title.split("<em class='found'>");
                    let tempArr1 = tempArr.join("").split("</em>");
                    return `${tempArr1.join(" ")} - ${o.theCode}`;
                  });
                  const temp = res?.map((ele: any) => {
                    return { label: ele, value: ele };
                  });

                  getICDList("Peritoneal Mesothelioma")
                    .then((data2: any) => {
                      const res2Options = data2.data.destinationEntities;
                      const res2 = res2Options.map((o: any) => {
                        let tempArr2 = o.title.split("<em class='found'>");
                        let tempArr3 = tempArr2.join("").split("</em>");
                        return `${tempArr3.join(" ")} - ${o.theCode}`;
                      });
                      const temp2 = res2?.map((ele: any) => {
                        return { label: ele, value: ele };
                      });
                      const tempIcdOptions: any = { ...icdOptions };
                      tempIcdOptions[`${each.cancerType}`] = [
                        ...temp,
                        ...temp2,
                      ];
                      setIcdOptions((prevIcdOptions: any) => {
                        return { ...prevIcdOptions, ...tempIcdOptions };
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                      const tempIcdOptions: any = { ...icdOptions };
                      tempIcdOptions[`${each.cancerType}`] = [...temp];
                      setIcdOptions((prevIcdOptions: any) => {
                        return { ...prevIcdOptions, ...tempIcdOptions };
                      });
                    });
                })
                .catch((err) => {
                  console.log(err);
                  const tempIcdOptions: any = { ...icdOptions };
                  tempIcdOptions[`${each.cancerType}`] = [];
                  setIcdOptions((prevIcdOptions: any) => {
                    return { ...prevIcdOptions, ...tempIcdOptions };
                  });
                });
            }
          } else if (
            each?.cancerType ===
            "Chronic Lymphocytic Leukemia Or Small Lymphocytic Lymphoma"
          ) {
            if (
              !icdOptions[
              `Chronic Lymphocytic Leukemia Or Small Lymphocytic Lymphoma`
              ]
            ) {
              getICDList("Chronic lymphocytic leukemia")
                .then((data) => {
                  const resOptions = data.data.destinationEntities;
                  const res = resOptions.map((o: any) => {
                    let tempArr = o.title.split("<em class='found'>");
                    let tempArr1 = tempArr.join("").split("</em>");
                    return `${tempArr1.join(" ")} - ${o.theCode}`;
                  });
                  const temp = res?.map((ele: any) => {
                    return { label: ele, value: ele };
                  });

                  getICDList("Small lymphocytic lymphoma")
                    .then((data2: any) => {
                      const res2Options = data2.data.destinationEntities;
                      const res2 = res2Options.map((o: any) => {
                        let tempArr2 = o.title.split("<em class='found'>");
                        let tempArr3 = tempArr2.join("").split("</em>");
                        return `${tempArr3.join(" ")} - ${o.theCode}`;
                      });
                      const temp2 = res2?.map((ele: any) => {
                        return { label: ele, value: ele };
                      });
                      const tempIcdOptions: any = { ...icdOptions };
                      tempIcdOptions[`${each.cancerType}`] = [
                        ...temp,
                        ...temp2,
                      ];
                      setIcdOptions((prevIcdOptions: any) => {
                        return { ...prevIcdOptions, ...tempIcdOptions };
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                      const tempIcdOptions: any = { ...icdOptions };
                      tempIcdOptions[`${each.cancerType}`] = [...temp];
                      setIcdOptions((prevIcdOptions: any) => {
                        return { ...prevIcdOptions, ...tempIcdOptions };
                      });
                    });
                })
                .catch((err) => {
                  console.log(err);
                  const tempIcdOptions: any = { ...icdOptions };
                  tempIcdOptions[`${each.cancerType}`] = [];
                  setIcdOptions((prevIcdOptions: any) => {
                    return { ...prevIcdOptions, ...tempIcdOptions };
                  });
                });
            }
          } else if (each?.cancerType === "Occult Primary Cancer") {
            if (!icdOptions[`Occult Primary Cancer`]) {
              getICDList("cancers of unknown primary")
                .then((data) => {
                  const resOptions = data.data.destinationEntities;
                  const res = resOptions.map((o: any) => {
                    let tempArr = o.title.split("<em class='found'>");
                    let tempArr1 = tempArr.join("").split("</em>");
                    return `${tempArr1.join(" ")} - ${o.theCode}`;
                  });
                  const temp = res?.map((ele: any) => {
                    return { label: ele, value: ele };
                  });
                  const tempIcdOptions: any = { ...icdOptions };
                  tempIcdOptions[`${each.cancerType}`] = temp;
                  setIcdOptions((prevIcdOptions: any) => {
                    return { ...prevIcdOptions, ...tempIcdOptions };
                  });
                })
                .catch((err) => {
                  console.log(err);
                  const tempIcdOptions: any = { ...icdOptions };
                  tempIcdOptions[`${each.cancerType}`] = [];
                  setIcdOptions((prevIcdOptions: any) => {
                    return { ...prevIcdOptions, ...tempIcdOptions };
                  });
                });
            }
          } else {
            if (!icdOptions[`${each?.cancerType}`]) {
              getICDList(each?.cancerType)
                .then((data) => {
                  const resOptions = data.data.destinationEntities;
                  const res = resOptions.map((o: any) => {
                    let tempArr = o.title.split("<em class='found'>");
                    let tempArr1 = tempArr.join("").split("</em>");
                    return `${tempArr1.join(" ")} - ${o.theCode}`;
                  });
                  const temp = res?.map((ele: any) => {
                    return { label: ele, value: ele };
                  });
                  tempIcdOptions[`${each.cancerType}`] = temp;
                  setIcdOptions((prevIcdOptions: any) => {
                    return { ...prevIcdOptions, ...tempIcdOptions };
                  });
                })
                .catch((err) => {
                  console.log(err);
                  const tempIcdOptions: any = { ...icdOptions };
                  tempIcdOptions[`${each.cancerType}`] = [];
                  setIcdOptions((prevIcdOptions: any) => {
                    return { ...prevIcdOptions, ...tempIcdOptions };
                  });
                });
            }
          }
        }
      });
      setIsLoading(false);
      if (!(concatCancerType.join() === concactCancer.join())) {
        setConcatCancerType(concactCancer);
      }
    }
  }, [stagingData]);

  //To fetch The synchronous cancer template
  useEffect(() => {
    // handleDataClear();
    if (concatCancerType?.length > 0) {
      setTemplate({});
      let query = "";
      concatCancerType?.forEach((each: any) => {
        query = query + `subTypeIds=${each}&`;
      });
      // setIsLoading(true);
      getCancerTemplateDataName(query)
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.pages[0]["readOnly"] || isReadOnly) {
            const temp = { ...res?.data };
            temp["showNavigationButtons"] = "none";
            temp["pages"][0]["readOnly"] = true;
            setTemplate(temp);
          } else {
            const temp = { ...res?.data };
            temp["clearInvisibleValues"] = "onHidden"
            setTemplate(temp);
          }
          // setSurveyData({})
          checkSavedData();
        })
        .catch((err) => {
          console.log(err?.name);
          setIsLoading(false);
          setTemplate({});
        });
    } else {
      setTemplate({});
    }
  }, [concatCancerType]);

  const updateInputValues = (value: any) => {

    const tempFullICDValue: any = value?.map((item: any) => {
      return item?.icd
    })

    const tempICDValue: any = value?.map((item: any) => {
      return item?.icd?.split(' - ')[1]
    })

    setInputFullICDValue(tempFullICDValue)
    setInputICDValue(tempICDValue)

  }


  //To hide cd4 field for non T-Cell Lymphoma cancers
  const getCd4Element = () => {
    const cancerNamesList: any = [];
    stagingData?.forEach((each: any) => {
      cancerNamesList.push(each?.cancerType);
    });
    var element: any = document?.querySelector(
      '[data-key="cd4Count_TcellNHL0"]'
    );
    if (element) {
      if (!cancerNamesList?.includes("T-Cell Lymphoma")) {
        element.style.display = "none";
        // modifyTemplateForCd4();
      } else {
        element.style.display = "block";
      }
    }
  };

  const modifyTemplateForCd4 = () => {
    const tempJson = { ...template };
    tempJson?.pages?.length > 0 &&
      tempJson?.pages[0]?.elements?.forEach((ele: any, index: any) => {
        if (ele?.name === "cd4Count_TcellNHL") {
          tempJson?.pages[0]?.elements?.splice(index, 1);
        } else if (ele?.name === "cd4CountDetails_TcellNHL") {
          tempJson?.pages[0]?.elements?.splice(index, 1);
        }
      });
    setTemplate({});
    setTimeout(() => {
      setTemplate(tempJson);
    }, 0);
  };

  const checkSavedData = () => {
    // setIsLoading(true);
    getCancerTemplateData({ patientId: patientId })
      .then((res: any) => {
        setIsLoading(false);
        const savedCancerArr: any = res?.diagnosis?.map(
          (each: any) => each?.cancerType
        );
        if (savedCancerArr.join() === concatCancerType.join()) {
          setSurveyData(res?.staging);
          setStagingData(res?.diagnosis);
          updateInputValues(res?.diagnosis);
        }
        handleDataClear()
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        handleDataClear()
      });
  };

  const handleDeleteRow = (index: number, cancerName: string) => {
    //Delete row
    const values = [...stagingData];
    values.splice(index, 1);
    //Delete icd options of corresponding row
    delete icdOptions[`${cancerName}`];
    if (values.length > 0) {
      setStagingData(values);
      updateInputValues(values);
    } else {
      setStagingData([stagingDataObj]);
      updateInputValues([stagingDataObj])
    }
  };

  const handleDataClear = () => {
    setIsLoading(true);
    if (template?.pages?.length > 0 && Object.keys(surveyData)?.length > 0) {
      const isEmpty = stagingData?.every((each: any) => {
        const isAllEmpty = Object.keys(each)?.every(
          (item: any) => !each[item] || each[item] === ""
        );
        return isAllEmpty;
      });
      if (!isEmpty) {
        let combinedCancerTypes = "";
        stagingData?.forEach((e: any) => {
          const temp = e?.cancerType?.split(" ")?.join("");
          if (temp === "AcuteMyeloidLeukemia") {
            combinedCancerTypes += "AML";
          } else if (temp === "AcuteLymphoblasticLeukemia") {
            combinedCancerTypes += "ALL";
          } else if (temp === "B-CellLymphoma") {
            combinedCancerTypes += "BcellNHL";
          } else if (
            temp === "ChronicLymphocyticLymphomaOrSmallLymphocyticLymphoma"
          ) {
            combinedCancerTypes += "CLLSLL";
          } else if (temp === "ChronicMyeloidLeukemia") {
            combinedCancerTypes += "CML";
          } else if (temp === "EsophagusEsophagogastricJunction") {
            combinedCancerTypes += "EsophagusAndEsophagogastricJunction";
          } else if (temp === "GestationalTrophoblasticNeoplasm") {
            combinedCancerTypes += "GTN";
          } else if (temp === "HodgkinsLymphoma") {
            combinedCancerTypes += "Hodgkins_Lymphoma";
          } else if (temp === "MultipleMyeloma") {
            combinedCancerTypes += "Multiple_Myeloma";
          } else if (temp === "MyelodysplasticSyndrome") {
            combinedCancerTypes += "MDS";
          } else if (temp === "MyeloproliferativeNeoplasms") {
            combinedCancerTypes += "MPN";
          } else if (temp === "NeuroendocrineTumour") {
            combinedCancerTypes += "NET";
          } else if (temp === "PleuralMesotheliomaOrPeritonealMesothelioma") {
            combinedCancerTypes +=
              "Pleural_Mesothelioma_or_Peritoneal_Mesothelioma";
          } else if (temp === "RenalCellCarcinoma") {
            combinedCancerTypes += "RCC";
          } else if (temp === "T-CellLymphoma") {
            combinedCancerTypes += "TcellNHL";
          } else if (temp === "ProstateCancer") {
            combinedCancerTypes += "ProstateCancer";
            combinedCancerTypes += "ProstrateCancer";
          } else {
            combinedCancerTypes += temp;
          }
        });
        const data = { ...surveyData };
        if (Object?.keys(data)?.length > 0) {
          for (const key in data) {
            if (key?.includes("currentTreatmentPlan")) {
              //Extracted currentTreatmentPlan panel json from template
              const currentTreatmentPlanJson = template?.pages[0]?.elements?.find((each: any) => each?.name?.includes("currentTreatmentPlan"))
              //Type of treatment choices
              const dropdownChoices = currentTreatmentPlanJson?.templateElements?.find((ele: any) => ele?.name?.includes("typeOfTreatment"))?.templateElements?.find((e: any) => e?.name?.includes("typeOfTreatmentSelected"))?.choices || []
              console.log("dropdown choices", dropdownChoices)
              //Type of treatment choices metastatic
              const dropdownChoicesMetastatic = currentTreatmentPlanJson?.templateElements?.find((ele: any) => ele?.name?.includes("typeOfTreatmentMetastatic"))?.templateElements?.find((e: any) => e?.name?.includes("typeOfTreatmentSelected"))?.choices || []
              console.log("dropdown choices", dropdownChoices)
              //Copy of currentTreatmentPlan
              const tempCurrentTreatmentValue: any = [...data[`${key}`]]
              //Manipulate currentTreatmentPlan value
              tempCurrentTreatmentValue?.forEach((e: any, index: any) => {
                const eachItem: any = { ...e }
                //Keys of individual Current Treatment Value
                const currentTreatmentObjectKeys: any = Object.keys(eachItem)
                //Type of Treatment Key
                const typeOfTreatmentKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("typeOfTreatment")
                }) || null
                const typeOfTreatmentKeyMetastaticKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("typeOfTreatmentMetastatic")
                }) || null
                //Type of Treatment Value
                const typeOfTreatmentValue: any = eachItem[typeOfTreatmentKey]
                //Type of Treatment Value Metastatic
                const typeOfTreatmentMetastaticValue: any = eachItem[typeOfTreatmentKeyMetastaticKey]
                //Updated Type of Treatment Value to remove cancer specific keys
                const filteredTypeOfTreatmentValue: any = typeOfTreatmentValue?.filter((each: any) => {
                  const typeOfTreatmentSelectedKey: any = Object.keys(each)?.find((element: any) => {
                    return element?.includes("typeOfTreatmentSelected")
                  }) || null
                  return dropdownChoices?.includes(each[typeOfTreatmentSelectedKey])
                })
                //Updated Type of Treatment Value to remove cancer specific keys
                const filteredtypeOfTreatmentMetastaticValue: any = typeOfTreatmentMetastaticValue?.filter((each: any) => {
                  const typeOfTreatmentSelectedKey: any = Object.keys(each)?.find((element: any) => {
                    return element?.includes("typeOfTreatmentSelected")
                  }) || null
                  return dropdownChoicesMetastatic?.includes(each[typeOfTreatmentSelectedKey])
                })
                //Update corresponding tempCurrentTreatmentValue index
                tempCurrentTreatmentValue[index][typeOfTreatmentKey] = filteredTypeOfTreatmentValue
                //Update corresponding tempCurrentTreatmentValue index
                tempCurrentTreatmentValue[index][typeOfTreatmentKey] = filteredtypeOfTreatmentMetastaticValue
              })
              //update data for currentTreatmentPlan key
              data[key] = tempCurrentTreatmentValue
            } else if (
              key !== "currentTreatmentPlan" &&
              key !== "hbsAgTest" &&
              key !== "hcvTest" &&
              key !== "hivTest" &&
              key !== "investigation_LowerGiEndoscopy" &&
              key !== "molecularMarkers" &&
              key !== "ngsTesting" &&
              key !== "ngsTestingYes" &&
              key !== "pastTreatment" &&
              key !== "pastTreatmentDetails" &&
              key !== "tumorMarkers" &&
              key !== "investigation" &&
              key !== "investigation_Colonoscopy" &&
              key !== "ldhDate" &&
              key !== "investigation_Endoscopy" &&
              key !== "ca125Result" &&
              key !== "bhcgResult" &&
              key !== "afpResult" &&
              key !== "ldhResult" &&
              key !== "ca19pt9" &&
              key !== "ca19pt9Value" &&
              key !== "ca19pt9Date" &&
              key !== "ca19pt9Result" &&
              key !== "otherMarkers" &&
              key !== "turbt" &&
              key !== "turbtFindings" &&
              key !== "unfavorable" &&
              key !== "favorable" &&
              key !== "csfExamination" &&
              key !== "csfExaminationResult" &&
              key !== "csfExaminationResult" &&
              key !== "molecularTesting" &&
              key !== "fatigueSevere" &&
              key !== "drenchingNightSweats" &&
              key !== "feverWithoutInfection" &&
              key !== "unintentionalWeightLoss" &&
              key !== "progressiveBulkyDisease" &&
              key !== "progressiveAnaemia" &&
              key !== "threatenedEndOrganFunction" &&
              key !== "progressiveThrombocytopenia" &&
              key !== "steroidRefractoryAutoimmuneCytopenias" &&
              key !== "afpDate" &&
              key !== "afpResult" &&
              key !== "targetedTherapyMarkers" &&
              key !== "braf" &&
              key !== "pdl1" &&
              key !== "pdl1Percentage" &&
              key !== "pdl1Platform" &&
              key !== "revisedInternationalPrognostic" &&
              key !== "whoBased" &&
              key !== "del5q" &&
              key !== "epoLevels" &&
              key !== "serumB12Levels" &&
              key !== "ldhLevels" &&
              key !== "ca125Date" &&
              key !== "bhcgDate" &&
              key !== "investigation_Thyroid"
            ) {
              const cancerTypeKey = key?.split("_");
              if (
                cancerTypeKey[cancerTypeKey?.length - 1]?.split("-")?.length > 0
              ) {
                const subCancerTypeKey =
                  cancerTypeKey[cancerTypeKey?.length - 1]?.split("-");
                if (!combinedCancerTypes?.includes(subCancerTypeKey[0])) {
                  delete data[`${key}`];
                }
              } else {
                if (
                  !combinedCancerTypes?.includes(
                    cancerTypeKey[cancerTypeKey?.length - 1]
                  )
                ) {
                  delete data[`${key}`];
                }
              }
            }
          }
        }
        setSurveyData(data);
      }
    }
    setIsLoading(false);
  };

  // function scroll() {
  //   const element = document.getElementById("patientDiagnosis");
  //   if (element) {
  //     element.scrollIntoView({ behavior: "smooth" });
  //   }
  // }

  console.log("stagingData", stagingData)

  function getIcdString(options: any = [], icdValue: any) {
    const filtered: any = options?.filter((e: any) => e?.label === icdValue);
    if (filtered?.length > 0) {
      if (filtered[0]?.value) {
        const temp = filtered[0]["value"]?.split(" - ");
        if (temp?.length > 0) {
          return {
            label: temp[1],
            value: temp[1],
          };
        }
      } else {
        return {
          label: icdValue,
          value: icdValue,
        };
      }
    } else if (icdValue?.includes('-')) {
      const temp = icdValue?.split(" - ");
      if (temp?.length > 0) {
        return {
          label: temp[1],
          value: temp[1],
        };
      }
    } else {
      return {
        label: icdValue,
        value: icdValue,
      };
    }
  }

  //Function to format payload before saving staging data
  const formatStagingData = (survey: any, dataObj: any) => {
    //Concated cancer names of current selection
    let combinedCancerTypes = "";
    stagingData?.forEach((e: any) => {
      const temp = e?.cancerType?.split(" ")?.join("");
      combinedCancerTypes += temp
    });
    //Copy of the data object
    const formattedPayload: any = { ...dataObj };
    //Current template question keys
    const questions: any = survey?.getAllQuestions();
    //Retrieve visible questions
    const visibleQuestions: any = questions?.filter((question: any) => question?.isVisible);
    // Extract question names
    const questionKeys: any = visibleQuestions?.map((question: any) => question?.name);
    //Current survey data keys
    const dataKeys: any = Object.keys(formattedPayload)
    //Clear redundant data from the payload object based on current template json questions
    for (const key of dataKeys) {
      if (!key?.includes("Comment")) {
        if (!questionKeys?.includes(key)) {
          delete formattedPayload[key];
        }
      }
    }
    const metastasisSiteKeys: any = Object.keys(formattedPayload)?.filter((element: any) => element?.includes("metastasisSite")) || null;

    const primarySiteKeys: any = Object.keys(formattedPayload)?.filter((element: any) => element?.includes("primarySite")) || null;

    const currentTreatmentPlanKeys: any = Object.keys(formattedPayload)?.filter((element: any) => {
      return element?.includes("currentTreatmentPlan")
    }) || []

    const pastTreatmentPlanKeys: any = Object.keys(formattedPayload)?.filter((element: any) => {
      return element?.includes("pastTreatmentDetails")
    }) || []

    const clinicalStagingKey: any = Object.keys(formattedPayload)?.find((element: any) => {
      return element?.includes("clinicalStaging")
    }) || null

    const pathologicalStagingKey: any = Object.keys(formattedPayload)?.find((element: any) => {
      return element?.includes("pathologicalStaging")
    }) || null

    if (Object.keys(formattedPayload)?.length > 0) {
      if (Object.keys(formattedPayload)?.includes("tumorMarkers")) {
        if (formattedPayload["tumorMarkers"]) {
          if (formattedPayload["tumorMarkers"]?.length > 0) {
            const tempValueTumorMarkers: any = [...formattedPayload["tumorMarkers"]]
            tempValueTumorMarkers?.forEach((e: any, index: any) => {
              const eachItem: any = { ...e }
              const tumorMarkerName: any = e?.tumorMarkerDesc
              const tumorMarkerNameModified: any = tumorMarkerName?.replace(/[()/;-]/g, '')?.toLowerCase()
              if (tumorMarkerNameModified) {
                var regex: any = new RegExp(tumorMarkerNameModified, "i")
              }
              for (const key in e) {
                if (key !== "tmDate" && key !== "tumorMarkerDesc" && key !== "tmResult" && key !== "tumorMarkerDesc-Comment") {
                  if (regex) {
                    if (!regex?.test(key?.toLowerCase())) {
                      if (!tumorMarkerNameModified?.includes(key?.toLowerCase())) {
                        delete eachItem[key];
                      }
                    }
                  }
                } else if (key === "tumorMarkerDesc-Comment" && tumorMarkerName !== "other") {
                  delete eachItem[key]
                } else if ((key === "tmDate" || key === "tmResult") && tumorMarkerName === "NA") {
                  delete eachItem[key]
                }
              }
              tempValueTumorMarkers[index] = eachItem
            })
            const finalTumorMarkersValue: any = tempValueTumorMarkers?.filter((each: any) => Object.keys(each)?.length > 0)
            if (finalTumorMarkersValue?.length > 0) {
              formattedPayload["tumorMarkers"] = finalTumorMarkersValue
            } else {
              delete formattedPayload["tumorMarkers"]
            }
          }
        }
      }
      if (Object.keys(formattedPayload).includes("molecularMarkers")) {
        if (formattedPayload["molecularMarkers"]) {
          if (formattedPayload["molecularMarkers"]?.length > 0) {
            const tempValueMolecularMarkers: any = [...formattedPayload["molecularMarkers"]]
            tempValueMolecularMarkers?.forEach((e: any, index: any) => {
              const eachItem: any = { ...e }
              const molecularMarkerName: any = e?.molecularMarkerDesc
              const molecularMarkerNameModified: any = molecularMarkerName?.replace(/[ ()/;-]/g, '')?.toLowerCase()
              if (molecularMarkerNameModified) {
                var regex: any = new RegExp(molecularMarkerNameModified, "i")
              }
              for (const key in e) {
                if (key !== "mmDate" && key !== "molecularMarkerDesc" && key !== "mmResult" && key !== "molecularMarkerDesc-Comment" && key !== "idhMutation") {
                  if (regex) {
                    if (!regex?.test(key?.toLowerCase())) {
                      if (!molecularMarkerNameModified?.includes(key?.toLowerCase())) {
                        delete eachItem[key];
                      }
                    }
                  } else if (!regex || !molecularMarkerName) {
                    console.log("molecular marker")
                    delete eachItem[key]
                  }
                } else if (key === "molecularMarkerDesc-Comment" && molecularMarkerName !== "other") {
                  delete eachItem[key]
                } else if ((key === "mmDate" || key === "mmResult" || key === "idhMutation") && molecularMarkerName === "NA") {
                  delete eachItem[key]
                }
              }
              tempValueMolecularMarkers[index] = eachItem
            })
            const finalMolecularMarkersValue: any = tempValueMolecularMarkers?.filter((each: any) => Object.keys(each)?.length > 0)
            if (finalMolecularMarkersValue?.length > 0) {
              formattedPayload["molecularMarkers"] = finalMolecularMarkersValue
            } else {
              delete formattedPayload["molecularMarkers"]
            }
          }
        }
      }
      if (Object.keys(formattedPayload)?.includes("investigation")) {
        if (formattedPayload["investigation"]) {
          if (formattedPayload["investigation"]?.length > 0) {
            const tempValueInvestigations: any = [...formattedPayload["investigation"]]
            tempValueInvestigations?.forEach(async (e: any, index: any) => {
              const eachItem: any = { ...e }
              const testName: any = e?.test?.replace(/[()/; -]/g, '')
              if (testName) {
                var regex: any = new RegExp(testName, "i")
              }
              for (const key in e) {
                if (key !== "dateOfTest" && key !== "test" && key !== "testFindings" && key !== "uploadFile" && key !== "test-Comment") {
                  if (regex) {
                    if (!regex?.test(key)) {
                      delete eachItem[key];
                    }
                  } else if (!regex || !testName) {
                    delete eachItem[key];
                  }
                }
              }
              tempValueInvestigations[index] = eachItem
            })
            formattedPayload["investigation"] = tempValueInvestigations
          }
        }
      }
      if (metastasisSiteKeys?.length > 0) {
        metastasisSiteKeys?.forEach((metastasisSiteKey: any) => {
          if (Object.keys(formattedPayload)?.includes(metastasisSiteKey)) {
            if (Array.isArray(formattedPayload[metastasisSiteKey]) && formattedPayload[metastasisSiteKey]?.length > 0) {
              const filteredMetastasisData = formattedPayload[metastasisSiteKey]?.filter((each: any) => Object.keys(each)?.length !== 0)
              if (filteredMetastasisData?.length === 0) {
                delete formattedPayload[metastasisSiteKey]
              } else {
                formattedPayload[metastasisSiteKey] = filteredMetastasisData
              }
            }
          }
        })
      }
      if (primarySiteKeys?.length > 0) {
        primarySiteKeys?.forEach((primarySiteKey: any) => {
          if (Object.keys(formattedPayload)?.includes(primarySiteKey)) {
            if (Array.isArray(formattedPayload[primarySiteKey]) && formattedPayload[primarySiteKey]?.length > 0) {
              const filteredPrimaryData: any = formattedPayload[primarySiteKey]?.filter((each: any) => Object.keys(each)?.length !== 0)
              if (filteredPrimaryData?.length === 0) {
                delete formattedPayload[primarySiteKey]
              } else {
                formattedPayload[primarySiteKey] = filteredPrimaryData
              }
            }
            else if (formattedPayload[primarySiteKey]) {
              if (Object.keys(formattedPayload[primarySiteKey])?.length === 0) {
                delete formattedPayload[primarySiteKey]
              }
            }
          }
        })
      }
      if (currentTreatmentPlanKeys?.length > 0) {
        currentTreatmentPlanKeys?.forEach((currentTreatmentPlanKey: any) => {
          if (Object.keys(formattedPayload)?.includes(currentTreatmentPlanKey)) {
            if (formattedPayload[currentTreatmentPlanKey]?.length > 0) {
              //Current Treatment Value Object
              const tempValueCurrentTreatmentPlan: any = [...formattedPayload[currentTreatmentPlanKey]]

              formattedPayload[currentTreatmentPlanKey]?.forEach((e: any, index: any) => {
                const eachItem: any = { ...e }
                //Keys of individual Current Treatment Value
                const currentTreatmentObjectKeys: any = Object.keys(eachItem)
                //Type of Treatment Key
                const typeOfTreatmentKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("typeOfTreatment")
                }) || null
                //Type of Issue key
                const typeOfIssueKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("typeOfIssue")
                }) || null
                //no of cycles
                const noOfCyclesCurrent: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("noOfCycles")
                }) || null
                //Category Selected key
                const categorySelectedKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("category")
                }) || null
                //Line of Treatment key
                const lineOfTreatmentKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("lineOfTreatment")
                }) || null
                //Treatment Intent key
                const treatmentIntentKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("treatmentIntent")
                }) || null
                //Risk Based On IPSS key
                const riskBasedOnIPSSKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("riskBasedOnIPSS")
                }) || null
                //Risk Based On IPSS value
                const riskBasedOnIPSSValue: any = eachItem[riskBasedOnIPSSKey] || null
                //localRtChoice key
                const localRtChoiceKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                  return element?.includes("localRtChoice")
                }) || null
                //localRtChoice value
                const localRtChoiceValue: any = eachItem[localRtChoiceKey] || null

                for (const key in e) {
                  if (key?.includes("nonMuscleInvasive")) {
                    if (tempValueCurrentTreatmentPlan[index][typeOfIssueKey] !== "Non-muscle invasive") {
                      delete tempValueCurrentTreatmentPlan[index][key]
                    }
                  }

                  if (key?.includes("typeOfTreatmentMetastatic_BladderCancer")) {
                    if (
                      tempValueCurrentTreatmentPlan[index][typeOfIssueKey] !== "Metastatic" ||
                      tempValueCurrentTreatmentPlan[index][key]?.length === 0 ||
                      !tempValueCurrentTreatmentPlan[index][key]
                    ) {
                      delete tempValueCurrentTreatmentPlan[index][key]
                    } else if (tempValueCurrentTreatmentPlan[index][key]?.length > 0) {
                      const temptypeOfTreatmentValue: any = [...formattedPayload[currentTreatmentPlanKey][index][key]]?.filter((eachObj: any) => {
                        const treatmentValueKeys: any = Object.keys(eachObj)
                        let typeOfTreatmentSelectedKey: any = treatmentValueKeys?.find((element: any) => {
                          return element?.includes("typeOfTreatmentSelected")
                        }) || null
                        if (typeOfTreatmentSelectedKey || eachObj[typeOfTreatmentSelectedKey]) {
                          return true
                        } else {
                          return false
                        }
                      })
                      if (temptypeOfTreatmentValue?.length > 0) {
                        tempValueCurrentTreatmentPlan[index][key] = temptypeOfTreatmentValue
                      } else {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      }
                    }
                  }

                  if (key?.includes("typeOfTreatment_BladderCancer")) {
                    if (tempValueCurrentTreatmentPlan[index][typeOfIssueKey] !== "Muscle invasive") {
                      delete tempValueCurrentTreatmentPlan[index][key]
                    }
                  }

                  if (key?.includes("typeOfTreatment_BreastCancer")) {
                    if (
                      tempValueCurrentTreatmentPlan[index][key]?.length === 0 ||
                      !tempValueCurrentTreatmentPlan[index][key] ||
                      !tempValueCurrentTreatmentPlan[index][categorySelectedKey]
                    ) {
                      delete tempValueCurrentTreatmentPlan[index][key]
                    } else if (
                      tempValueCurrentTreatmentPlan[index][key]?.length > 0 && tempValueCurrentTreatmentPlan[index][categorySelectedKey] !== "NACT/Adjuvant"
                    ) {
                      const temptypeOfTreatmentValue: any = [...formattedPayload[currentTreatmentPlanKey][index][key]]?.filter((eachObj: any) => {
                        const treatmentValueKeys: any = Object.keys(eachObj)
                        let typeOfTreatmentSelectedKey: any = treatmentValueKeys?.find((element: any) => {
                          return element?.includes("typeOfTreatmentSelected")
                        }) || null
                        if (
                          typeOfTreatmentSelectedKey &&
                          eachObj[typeOfTreatmentSelectedKey] !== "HER2 Positive" &&
                          eachObj[typeOfTreatmentSelectedKey] !== "HER2 Negative"
                        ) {
                          return true
                        } else {
                          return false
                        }
                      })
                      if (temptypeOfTreatmentValue?.length > 0) {
                        tempValueCurrentTreatmentPlan[index][key] = temptypeOfTreatmentValue
                      } else {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      }
                    }
                  }

                  if (key === typeOfTreatmentKey) {

                    if ((formattedPayload[currentTreatmentPlanKey][index][categorySelectedKey] === "NA" || !formattedPayload[currentTreatmentPlanKey][index][categorySelectedKey]) && combinedCancerTypes?.includes("BreastCancer")) {
                      delete tempValueCurrentTreatmentPlan[index][typeOfTreatmentKey]
                    }

                    if (formattedPayload[currentTreatmentPlanKey][index][key]) {
                      //Copy of Type of Treatment Value
                      const temptypeOfTreatmentValue: any = [...formattedPayload[currentTreatmentPlanKey][index][key]]

                      temptypeOfTreatmentValue?.forEach((eachTreatment: any, eachTreatmentIndex: any) => {
                        if (eachTreatment) {
                          //Keys of individual Type of Treatment Value
                          const treatmentValueKeys: any = Object.keys(eachTreatment)
                          //Category key
                          const categoryKey: any = treatmentValueKeys?.find((element: any) => {
                            return element?.includes("category")
                          }) || null
                          //Category value
                          const categoryValue: any = temptypeOfTreatmentValue[eachTreatmentIndex][categoryKey]
                          //Treatment type key
                          let typeOfTreatmentSelectedKey: any = treatmentValueKeys?.find((element: any) => {
                            return element?.includes("typeOfTreatmentSelected")
                          }) || null
                          //Treatment type value
                          let typeOfTreatmentSelectedValue: any = temptypeOfTreatmentValue[eachTreatmentIndex][typeOfTreatmentSelectedKey]
                          //Current treatment key
                          const currentTreatmentKey: any = treatmentValueKeys?.find((element: any) => {
                            return element?.includes("currentTreatment")
                          }) || null

                          //Current treatment value
                          const currentTreatmentValue: any = temptypeOfTreatmentValue[eachTreatmentIndex][currentTreatmentKey]
                          //No of cycles key
                          const noOfCyclesKey: any = treatmentValueKeys?.find((element: any) => {
                            return element?.includes("noOfCycles")
                          }) || null
                          //Immunotherapy key
                          const immunotherapyKey: any = treatmentValueKeys?.find((element: any) => {
                            return element?.includes("immunotherapy")
                          }) || null
                          //CTRT key
                          const ctrtKey: any = treatmentValueKeys?.find((element: any) => {
                            return element?.includes("ctrt")
                          }) || null
                          //Maintenance key
                          const maintenanceKey: any = treatmentValueKeys?.find((element: any) => {
                            return element?.includes("maintenance") && !element?.includes("maintenanceDetails")
                          }) || null
                          //Maintenance Details key
                          const maintenanceDetailsKey: any = treatmentValueKeys?.find((element: any) => {
                            return element?.includes("maintenanceDetails")
                          }) || null
                          //Maintenance value
                          const maintenanceValue: any = temptypeOfTreatmentValue[eachTreatmentIndex][maintenanceKey]

                          treatmentValueKeys?.forEach((TreatmentValuekey: any) => {
                            //Metastatic key
                            const metastaticKey: any = treatmentValueKeys?.find((element: any) => {
                              return element?.includes("metastatic")
                            }) || null
                            //Metastatic value
                            const metastaticValue: any = temptypeOfTreatmentValue[eachTreatmentIndex][metastaticKey]

                            if (metastaticValue && metastaticValue === "ADT") {
                              //Updated Treatment type key
                              typeOfTreatmentSelectedKey = treatmentValueKeys?.find((element: any) => {
                                return element?.includes("typeOfTreatmentSelectedAdt")
                              }) || null
                              //Treatment type value
                              typeOfTreatmentSelectedValue = temptypeOfTreatmentValue[eachTreatmentIndex][typeOfTreatmentSelectedKey]
                            }

                            if (
                              !(TreatmentValuekey === categoryKey ||
                                TreatmentValuekey === currentTreatmentKey ||
                                TreatmentValuekey === typeOfTreatmentSelectedKey ||
                                tempValueCurrentTreatmentPlan[index][typeOfIssueKey] === "Muscle invasive" &&
                                TreatmentValuekey?.includes("detailsOfTreatment") ||
                                tempValueCurrentTreatmentPlan[index][typeOfIssueKey] === "Metastatic" &&
                                TreatmentValuekey?.includes("noOfCycles") ||
                                tempValueCurrentTreatmentPlan[index][lineOfTreatmentKey] === "Metastatic" &&
                                TreatmentValuekey?.includes("metastatic")
                              )
                            ) {
                              if (
                                typeOfTreatmentSelectedValue === "Chemotherapy" ||
                                typeOfTreatmentSelectedValue === "Chemotherapy - Cisplatin Eligible" ||
                                typeOfTreatmentSelectedValue === "Chemotherapy - Cisplatin Ineligible"
                              ) {
                                if (
                                  (TreatmentValuekey !== "noOfCycles" &&
                                    (
                                      TreatmentValuekey !== noOfCyclesKey && (TreatmentValuekey !== "noOfCyclesTargeted Therapy" && TreatmentValuekey !== "noOfCyclesImmunotherapy")
                                    )
                                  ) &&
                                  TreatmentValuekey !== "chemotherapy" &&
                                  TreatmentValuekey !== "chemotherapy-Comment" &&
                                  (currentTreatmentKey && currentTreatmentValue) &&
                                  !(
                                    (combinedCancerTypes?.includes("MultipleMyeloma") || combinedCancerTypes?.includes("OvaryCancer")) && (
                                      TreatmentValuekey?.includes("maintenance") ||
                                      TreatmentValuekey?.includes("maintenanceDetails")
                                    )
                                  )
                                ) {
                                  if (currentTreatmentValue === "Adjuvant") {
                                    if (!(
                                      TreatmentValuekey?.includes("adjuvant")
                                    )) {
                                      delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                    }
                                  } else if (currentTreatmentValue === "Multi Agent") {
                                    if (!(
                                      TreatmentValuekey?.includes("multiAgentPalliative"))
                                    ) {
                                      delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                    }
                                  } else if (currentTreatmentValue === "NACT") {
                                    if (!(
                                      TreatmentValuekey?.includes("nact")
                                    )) {
                                      delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                    }
                                  } else if (currentTreatmentValue === "Single Agent") {
                                    if (
                                      !(
                                        TreatmentValuekey?.includes("singleAgent")
                                      )
                                    ) {
                                      delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                    }
                                  } else if (currentTreatmentValue === "NA") {
                                    delete temptypeOfTreatmentValue[eachTreatmentIndex][noOfCyclesKey]

                                    delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                  }
                                }
                              } else if (typeOfTreatmentSelectedValue === "Radiotherapy") {
                                //typeOfRadiotherapy key
                                const typeOfRadiotherapyKey: any = treatmentValueKeys?.find((element: any) => {
                                  return element?.includes("typeOfRadiotherapy")
                                }) || null
                                //typeOfRadiotherapy value
                                const typeOfRadiotherapyValue: any = temptypeOfTreatmentValue[eachTreatmentIndex][typeOfRadiotherapyKey]
                                if (
                                  !(TreatmentValuekey?.includes("detailsOfTreatment") ||
                                    TreatmentValuekey?.includes("typeOfRadiotherapy")) &&
                                  !((combinedCancerTypes?.includes("MultipleMyeloma") || combinedCancerTypes?.includes("OvaryCancer")) && (
                                    TreatmentValuekey?.includes("maintenance") ||
                                    TreatmentValuekey?.includes("maintenanceDetails")
                                  ))
                                ) {
                                  if (TreatmentValuekey?.includes("Radiation")) {
                                    if (typeOfRadiotherapyValue !== "ISRT") {
                                      delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                    }
                                  } else {
                                    delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                  }
                                }
                              } else if (
                                typeOfTreatmentSelectedValue === "Surgery" || typeOfTreatmentSelectedValue === "Others" || typeOfTreatmentSelectedValue === "Maintenance Applicable" || typeOfTreatmentSelectedValue === "PRRT" || typeOfTreatmentSelectedValue === "LAR/ Octreotide" || typeOfTreatmentSelectedValue === "CTRT" ||
                                typeOfTreatmentSelectedValue === "Radiation"
                              ) {
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][currentTreatmentKey]

                                if (!TreatmentValuekey?.includes("detailsOfTreatment") &&
                                  !((combinedCancerTypes?.includes("MultipleMyeloma") || combinedCancerTypes?.includes("OvaryCancer")) && (
                                    TreatmentValuekey?.includes("maintenance") ||
                                    TreatmentValuekey?.includes("maintenanceDetails")
                                  ))) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "Targeted Therapy") {
                                if (
                                  !(
                                    TreatmentValuekey?.includes("detailsOfTreatment") ||
                                    TreatmentValuekey?.includes("noOfCyclesTargeted Therapy") ||
                                    TreatmentValuekey?.includes("noOfCyclesTargetedTherapy") ||
                                    // (
                                    //   TreatmentValuekey === noOfCyclesKey && TreatmentValuekey !== "noOfCyclesImmunotherapy" &&
                                    // TreatmentValuekey !== "noOfCyclesChemotherapy"
                                    // ) ||
                                    TreatmentValuekey?.includes("targetedTherapy")
                                  ) &&
                                  !(
                                    (combinedCancerTypes?.includes("MultipleMyeloma") || combinedCancerTypes?.includes("OvaryCancer")) && (
                                      TreatmentValuekey?.includes("maintenance") ||
                                      TreatmentValuekey?.includes("maintenanceDetails")
                                    )
                                  )
                                ) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (
                                typeOfTreatmentSelectedValue === "Hormone Therapy" || typeOfTreatmentSelectedValue === "Nuclear Medicine" || typeOfTreatmentSelectedValue === "Intrathecal" ||
                                typeOfTreatmentSelectedValue === "Transplant" ||
                                typeOfTreatmentSelectedValue === "Local Treatment"
                              ) {
                                if (!TreatmentValuekey?.includes("detailsOfTreatment") &&
                                  !((combinedCancerTypes?.includes("MultipleMyeloma") || combinedCancerTypes?.includes("OvaryCancer")) && (
                                    TreatmentValuekey?.includes("maintenance") ||
                                    TreatmentValuekey?.includes("maintenanceDetails")
                                  ))) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "Immunotherapy") {
                                if (!TreatmentValuekey?.includes("immunotherapy") &&
                                  !TreatmentValuekey?.includes("noOfCyclesImmunotherapy") &&
                                  !((combinedCancerTypes?.includes("MultipleMyeloma") || combinedCancerTypes?.includes("OvaryCancer")) && (
                                    TreatmentValuekey?.includes("maintenance") ||
                                    TreatmentValuekey?.includes("maintenanceDetails")
                                  ))) {
                                  if (temptypeOfTreatmentValue[eachTreatmentIndex][immunotherapyKey] === "other" || temptypeOfTreatmentValue[eachTreatmentIndex][immunotherapyKey] === "NA") {
                                    delete temptypeOfTreatmentValue[eachTreatmentIndex][noOfCyclesKey]

                                    delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                  } else {
                                    if (TreatmentValuekey !== "noOfCyclesImmunotherapy"
                                      // &&(
                                      //   TreatmentValuekey !== noOfCyclesKey && (TreatmentValuekey !== "noOfCyclesTargeted Therapy"&& TreatmentValuekey !== "noOfCyclesTargetedTherapy" &&
                                      // TreatmentValuekey !== "noOfCyclesChemotherapy")
                                      // )
                                    ) {
                                      delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                    }
                                  }
                                }
                              } else if (typeOfTreatmentSelectedValue === "CTRT - Concurrent chemotherapy") {
                                if (!TreatmentValuekey?.includes("ctrt")) {
                                  if (temptypeOfTreatmentValue[eachTreatmentIndex][ctrtKey] === "NA") {
                                    delete temptypeOfTreatmentValue[eachTreatmentIndex][noOfCyclesKey]

                                    delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                  } else {
                                    if (TreatmentValuekey !== noOfCyclesKey) {
                                      delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                    }
                                  }
                                }
                              } else if (typeOfTreatmentSelectedValue === "Cystectomy") {
                                if (!TreatmentValuekey?.includes("detailsOfTreatment")) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "Bone Modifying Agents" || metastaticValue === "Bone Modifying Agents") {
                                if (
                                  !TreatmentValuekey?.includes("boneModifyingAgents") &&
                                  !((combinedCancerTypes?.includes("MultipleMyeloma") || combinedCancerTypes?.includes("OvaryCancer")) && (
                                    TreatmentValuekey?.includes("maintenance") ||
                                    TreatmentValuekey?.includes("maintenanceDetails")
                                  ))
                                ) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "Interventional Radiology") {
                                if (!TreatmentValuekey?.includes("interventionalRadiology")) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "Combination Therapies") {
                                if (!TreatmentValuekey?.includes("combinationTherapies")) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "Advanced treatment") {
                                if (!TreatmentValuekey?.includes("advancedTreatment")) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "HER2 Positive") {
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][categoryKey]

                                delete temptypeOfTreatmentValue[eachTreatmentIndex][currentTreatmentKey]

                                if (!(
                                  TreatmentValuekey?.includes("her2Positive") ||
                                  TreatmentValuekey?.includes("antiHer2") ||
                                  TreatmentValuekey?.includes("frequency") ||
                                  TreatmentValuekey?.includes("maintenance") ||
                                  TreatmentValuekey?.includes("noOfCyclesHER2Positive")
                                )) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "HER2 Negative") {
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][categoryKey]

                                delete temptypeOfTreatmentValue[eachTreatmentIndex][currentTreatmentKey]

                                if (!(
                                  TreatmentValuekey?.includes("her2NegativeImmunotherapy") ||
                                  TreatmentValuekey?.includes("her2NegativeChemotherapy") ||
                                  TreatmentValuekey?.includes("normalDoseDense") ||
                                  TreatmentValuekey?.includes("noOfCyclesHER2Negative")
                                )) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "Surgical Castration") {
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][categoryKey]

                                delete temptypeOfTreatmentValue[eachTreatmentIndex][currentTreatmentKey]

                                if (
                                  !(
                                    TreatmentValuekey?.includes("typeOfTreatmentSelectedAdt") ||
                                    TreatmentValuekey?.includes("surgicalCastration") ||
                                    !temptypeOfTreatmentValue[eachTreatmentIndex]["metastatic_ProstateCancer"] ||
                                    !temptypeOfTreatmentValue[eachTreatmentIndex]["typeOfTreatmentSelectedAdt_ProstateCancer"]
                                  )
                                ) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "Medical Castration") {
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][categoryKey]

                                delete temptypeOfTreatmentValue[eachTreatmentIndex][currentTreatmentKey]
                                if (
                                  !(
                                    TreatmentValuekey?.includes("typeOfTreatmentSelectedAdt") ||
                                    TreatmentValuekey?.includes("medicalCastration") ||
                                    !temptypeOfTreatmentValue[eachTreatmentIndex]["metastatic_ProstateCancer"] ||
                                    !temptypeOfTreatmentValue[eachTreatmentIndex]["typeOfTreatmentSelectedAdt_ProstateCancer"]
                                  )
                                ) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (typeOfTreatmentSelectedValue === "Adjuvant Treatment") {
                                if (
                                  !(
                                    TreatmentValuekey === typeOfTreatmentSelectedKey
                                    ||
                                    TreatmentValuekey?.includes("positiveMargin") ||
                                    TreatmentValuekey?.includes("seminalVesicleInvasion") ||
                                    TreatmentValuekey?.includes("extracapsularExtension") ||
                                    TreatmentValuekey?.includes("psaLevel") ||
                                    TreatmentValuekey?.includes("indication") ||
                                    TreatmentValuekey === currentTreatmentKey
                                  )
                                ) {
                                  delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                                }
                              } else if (!typeOfTreatmentSelectedKey || !typeOfTreatmentSelectedValue) {
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][currentTreatmentKey]
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]

                              }
                            } else if (TreatmentValuekey?.includes("Adt") && metastaticValue !== "ADT") {
                              delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                            }
                            if (tempValueCurrentTreatmentPlan[index][lineOfTreatmentKey] === "Metastatic") {
                              if (!metastaticValue) {
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                              }
                            }

                            if (TreatmentValuekey?.includes("surgicalCastration")) {
                              if (tempValueCurrentTreatmentPlan[index][lineOfTreatmentKey] !== "Metastatic") {
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                              }
                            }

                            if (TreatmentValuekey?.includes("medicalCastration")) {
                              if (tempValueCurrentTreatmentPlan[index][lineOfTreatmentKey] !== "Metastatic") {
                                delete temptypeOfTreatmentValue[eachTreatmentIndex][TreatmentValuekey]
                              }
                            }

                            if (maintenanceValue !== "Yes" || !maintenanceValue) {
                              delete temptypeOfTreatmentValue[eachTreatmentIndex][maintenanceDetailsKey]
                            }
                          })
                        }
                      })

                      const filteredTempTypeOfTreatmentValue: any = temptypeOfTreatmentValue?.filter((ele: any) => Object.keys(ele)?.length > 0)
                      if (filteredTempTypeOfTreatmentValue?.length > 0) {
                        //Update the list value of temptypeOfTreatment
                        tempValueCurrentTreatmentPlan[index][typeOfTreatmentKey] = filteredTempTypeOfTreatmentValue
                      } else {
                        delete tempValueCurrentTreatmentPlan[index][typeOfTreatmentKey]
                      }
                    }
                  }

                  if (key?.includes("maintenanceTreatment")) {
                    if (tempValueCurrentTreatmentPlan[index][typeOfIssueKey] !== "Maintenance treatment") {
                      delete tempValueCurrentTreatmentPlan[index][key]
                      delete tempValueCurrentTreatmentPlan[index][noOfCyclesCurrent]
                    }
                  }

                  if (key?.includes("ovarianAblation") || key?.includes("typeOfNactAdjuvant")) {
                    if (tempValueCurrentTreatmentPlan[index][categorySelectedKey] !== "NACT/Adjuvant") {
                      delete tempValueCurrentTreatmentPlan[index][key]
                    }
                  }

                  if (key === "radioDetailsIodineTreatment") {
                    if (
                      !combinedCancerTypes?.includes("ThyroidCancer") ||
                      tempValueCurrentTreatmentPlan[index]["radioIodineTreatment"] !== "Indicated" ||
                      !tempValueCurrentTreatmentPlan[index]["radioIodineTreatment"]
                    ) {
                      delete tempValueCurrentTreatmentPlan[index][key]
                    }
                  }

                  if (key === "radioIodineTreatment") {
                    if (!(combinedCancerTypes?.includes("ThyroidCancer"))) {
                      delete tempValueCurrentTreatmentPlan[index][key]
                    }
                  }

                  if (
                    key?.includes("riskBasedOnIPSS") ||
                    key?.includes("lowerRiskDisease") ||
                    key?.includes("higherRiskDisease") ||
                    key === "remarks" ||
                    key?.includes("systemicLRD") ||
                    key?.includes("noOfCyclesLRD") ||
                    key?.includes("SystemicHRD") ||
                    key?.includes("noOfCyclesHRD") ||
                    key?.includes("supportiveCareLRD") ||
                    key?.includes("supportiveCareHRD") ||
                    key?.includes("transplantCandidate")
                  ) {
                    //LRD Key
                    const lowerRiskDiseaseKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                      return element?.includes("lowerRiskDisease")
                    }) || null
                    //LRD Value
                    const lowerRiskDiseaseValue: any = eachItem[lowerRiskDiseaseKey] || null
                    //HRD Key
                    const higherRiskDiseaseKey: any = currentTreatmentObjectKeys?.find((element: any) => {
                      return element?.includes("higherRiskDisease")
                    }) || null
                    //HRD Value
                    const higherRiskDiseaseValue: any = eachItem[higherRiskDiseaseKey] || null
                    //Updation Logic
                    delete tempValueCurrentTreatmentPlan[index][typeOfTreatmentKey]
                    delete tempValueCurrentTreatmentPlan[index][typeOfIssueKey]
                    delete tempValueCurrentTreatmentPlan[index][categorySelectedKey]
                    delete tempValueCurrentTreatmentPlan[index][lineOfTreatmentKey]
                    delete tempValueCurrentTreatmentPlan[index][treatmentIntentKey]
                    if (!(key?.includes("riskBasedOnIPSS") || key === "remarks")) {
                      if (key === lowerRiskDiseaseKey && riskBasedOnIPSSValue !== "Lower Risk Disease") {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      } else if (key === higherRiskDiseaseKey && riskBasedOnIPSSValue !== "Higher Risk Disease") {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      } else if (
                        (key?.includes("noOfCyclesLRD") || key?.includes("systemicLRD")) && (lowerRiskDiseaseValue !== "Systemic" || riskBasedOnIPSSValue !== "Lower Risk Disease")
                      ) {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      } else if (
                        (key?.includes("noOfCyclesHRD") || key?.includes("SystemicHRD")) && (higherRiskDiseaseValue !== "Systemic treatment" || riskBasedOnIPSSValue !== "Higher Risk Disease")
                      ) {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      } else if (
                        key?.includes("supportiveCareLRD") && (lowerRiskDiseaseValue !== "Supportive Care" || riskBasedOnIPSSValue !== "Lower Risk Disease")
                      ) {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      } else if (
                        key?.includes("supportiveCareHRD") && (higherRiskDiseaseValue !== "Supportive Care" || riskBasedOnIPSSValue !== "Higher Risk Disease")
                      ) {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      } else if (
                        key?.includes("transplantCandidate") && (higherRiskDiseaseValue !== "Transplant Candidate" || riskBasedOnIPSSValue !== "Higher Risk Disease")
                      ) {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      }
                    } else if (key === "remarks") {
                      if (!riskBasedOnIPSSValue) {
                        delete tempValueCurrentTreatmentPlan[index][key]
                      }
                    }
                  }

                  if ((key?.includes("localRt") && !key?.includes("localRtChoice")) && localRtChoiceValue !== "Indicated") {
                    delete tempValueCurrentTreatmentPlan[index][key]
                  }

                  if (key?.includes("pleuralTappingDetails")) {
                    if (eachItem["pleuralTappingDone"] !== "Yes") {
                      delete tempValueCurrentTreatmentPlan[index][key]
                    }
                  }
                }
              })

              const filteredTempValueCurrentTreatmentPlan: any = tempValueCurrentTreatmentPlan?.filter((ele: any) => Object.keys(ele)?.length > 0)
              if (filteredTempValueCurrentTreatmentPlan?.length > 0) {
                formattedPayload[currentTreatmentPlanKey] = filteredTempValueCurrentTreatmentPlan
              } else {
                delete formattedPayload[currentTreatmentPlanKey]
              }
            }
          }
        })
      }
      if (pastTreatmentPlanKeys?.length > 0) {
        pastTreatmentPlanKeys?.forEach((pastTreatmentKey: any) => {
          if (Object.keys(formattedPayload)?.includes(pastTreatmentKey)) {
            //Copy of Past Treatment Value
            const tempValuePastTreatmentPlan: any = [...formattedPayload[pastTreatmentKey]]

            formattedPayload[pastTreatmentKey]?.forEach((e: any, index: any) => {
              //Response Criteria Value
              const responseCriteriaValue: any = tempValuePastTreatmentPlan[index]["responseCriteria"]
              //Toxicity Value
              const toxicityValue: any = tempValuePastTreatmentPlan[index]["toxicity"]
              //Toxicity Details Value
              const toxicityDetailsValue: any = tempValuePastTreatmentPlan[index]["toxicityDetails"]

              for (const key in e) {
                if (
                  key === "toxicityDetails" ||
                  key === "withTargetLesions" ||
                  key === "withoutTargetLesions" ||
                  key === "responseEvaluationCycle" ||
                  key === "Radiation"
                ) {
                  if (key === "responseEvaluationCycle" && responseCriteriaValue === "NA") {
                    delete tempValuePastTreatmentPlan[index][key]
                  }
                  else if (key === "toxicityDetails" && toxicityValue === false) {
                    delete tempValuePastTreatmentPlan[index][key]
                  }
                  else if (key === "toxicityDetails" && toxicityValue === true) {
                    //Copy of toxicity details
                    const tempToxicityDetailsValue: any = [...toxicityDetailsValue]

                    if (toxicityDetailsValue?.length > 0) {
                      toxicityDetailsValue?.forEach((eachToxicityValue: any, eachToxicityIndex: any) => {
                        const toxicityObjectKeys = Object.keys(eachToxicityValue)
                        //Individual toxicity detail object
                        const toxicityDetailValue: any = toxicityDetailsValue[eachToxicityIndex]["toxicityDetail"]

                        if (toxicityObjectKeys?.length > 0) {
                          toxicityObjectKeys?.forEach((toxicityObjKey: any) => {
                            if (!(
                              toxicityObjKey === "toxicityDetail" ||
                              toxicityObjKey === "gradeCtcae" ||
                              toxicityObjKey === "treatmentToManageToxicity" ||
                              toxicityObjKey === "remarks"
                            )) {
                              if (toxicityObjKey === "vomiting" && toxicityDetailValue !== "Vomiting") {
                                delete tempToxicityDetailsValue[eachToxicityIndex]["vomiting"]
                              } else if (toxicityObjKey === "diarrhea" && toxicityDetailValue !== "Diarrhea") {
                                delete tempToxicityDetailsValue[eachToxicityIndex]["diarrhea"]
                              } else if (toxicityObjKey === "constipation" && toxicityDetailValue !== "Constipation") {
                                delete tempToxicityDetailsValue[eachToxicityIndex]["constipation"]
                              } else if (toxicityObjKey === "abdominalPain" && toxicityDetailValue !== "Abdominal Pain") {
                                delete tempToxicityDetailsValue[eachToxicityIndex]["abdominalPain"]
                              } else if (toxicityObjKey === "mucositis" && toxicityDetailValue !== "Mucositis") {
                                delete tempToxicityDetailsValue[eachToxicityIndex]["mucositis"]
                              } else if (toxicityObjKey === "fever" && toxicityDetailValue !== "Fever") {
                                delete tempToxicityDetailsValue[eachToxicityIndex]["fever"]
                              } else if (toxicityObjKey === "peripheralMotorNeuropathy" && toxicityDetailValue !== "Peripheral Motor Neuropathy") {
                                delete tempToxicityDetailsValue[eachToxicityIndex]["peripheralMotorNeuropathy"]
                              }
                            }
                          })
                        }
                      })
                    }
                    //To update toxicity details
                    const filteredToxicityDetailsValue: any = toxicityDetailsValue?.filter((ele: any) => Object.keys(ele)?.length !== 0)
                    if (filteredToxicityDetailsValue?.length > 0) {
                      tempValuePastTreatmentPlan[index]["toxicityDetails"] = filteredToxicityDetailsValue
                    } else {
                      tempValuePastTreatmentPlan[index]["toxicity"] = false
                      delete tempValuePastTreatmentPlan[index]["toxicityDetails"]
                    }
                  }
                  else if (key?.includes("withTargetLesions") && (responseCriteriaValue !== "With Target Lesions" ||
                    responseCriteriaValue === "NA"
                  )) {
                    delete tempValuePastTreatmentPlan[index][key]
                  }
                  else if (key?.includes("withoutTargetLesions") && (responseCriteriaValue !== "Without Target Lesions" ||
                    responseCriteriaValue === "NA"
                  )) {
                    delete tempValuePastTreatmentPlan[index][key]
                  }
                  else if (key === "Radiation" && tempValuePastTreatmentPlan[index]["Type"] !== "Radiation") {
                    delete tempValuePastTreatmentPlan[index]["Radiation"]
                  }
                }
              }
            })
            formattedPayload[pastTreatmentKey] = tempValuePastTreatmentPlan
          }
        })
      }
      if (
        Object.keys(formattedPayload)?.includes("pathologicalStaging_CLLSLL") ||
        Object.keys(formattedPayload)?.includes("clinicalStaging_CLLSLL")
      ) {
        const histopathologyKey: any = Object.keys(formattedPayload)?.find((each: any) => each?.includes("histopathology"))
        const histopathologyValue: any = formattedPayload[histopathologyKey]
        if (formattedPayload["clinicalStaging_CLLSLL"]?.length > 0) {
          const tempClinicalStagingValue: any = { ...formattedPayload["clinicalStaging_CLLSLL"][0] }

          Object.keys(tempClinicalStagingValue)?.forEach((eachStagingKey: any) => {
            if (histopathologyValue === "SLL") {
              if (
                !(eachStagingKey?.includes("sllStage_CLLSLL") ||
                  eachStagingKey?.includes("sllStagingSystem")
                )
              ) {
                delete tempClinicalStagingValue[eachStagingKey]
              }
            } else if (histopathologyValue === "CLL") {
              if (
                (eachStagingKey?.includes("sllStage_CLLSLL") ||
                  eachStagingKey?.includes("sllStagingSystem")
                )
              ) {
                delete tempClinicalStagingValue[eachStagingKey]
              }
            }
          })
          formattedPayload["clinicalStaging_CLLSLL"][0] = tempClinicalStagingValue
        }
        if (formattedPayload["pathologicalStaging_CLLSLL"]?.length > 0) {
          const tempPathologicalStagingValue: any = { ...formattedPayload["pathologicalStaging_CLLSLL"][0] }

          Object.keys(tempPathologicalStagingValue)?.forEach((eachStagingKey: any) => {
            if (histopathologyValue === "SLL") {
              if (
                !(eachStagingKey?.includes("sllStage_CLLSLL") ||
                  eachStagingKey?.includes("sllStagingSystem")
                )
              ) {
                delete tempPathologicalStagingValue[eachStagingKey]
              }
            } else if (histopathologyValue === "CLL") {
              if (
                (eachStagingKey?.includes("sllStage_CLLSLL") ||
                  eachStagingKey?.includes("sllStagingSystem")
                )
              ) {
                delete tempPathologicalStagingValue[eachStagingKey]
              }
            }
          })
          formattedPayload["pathologicalStaging_CLLSLL"][0] = tempPathologicalStagingValue
        }
      }
      if (
        Object.keys(formattedPayload)?.includes("diagnosis_HCC")
      ) {
        const tempHccDiagnosisValue: any = formattedPayload["diagnosis_HCC"]
        if (tempHccDiagnosisValue?.length > 0) {
          tempHccDiagnosisValue?.forEach((eachDiagnosis: any, index: any) => {
            const tempEachDiagnosisValue: any = { ...eachDiagnosis }
            const eachDiagnosisKeys: any = Object.keys(tempEachDiagnosisValue)
            const biopsyKey: any = eachDiagnosisKeys?.find((each: any) => each?.includes("biopsyNeeded_HCC"))
            const biopsyValue: any = tempEachDiagnosisValue[biopsyKey]
            eachDiagnosisKeys?.forEach((eachKey: any) => {
              if (eachKey?.includes("hpe_HCC")) {
                if (!biopsyValue || biopsyValue !== true) {
                  delete tempEachDiagnosisValue["hpe_HCC"]
                }
              }
            })
            tempHccDiagnosisValue[index] = tempEachDiagnosisValue
          })
          formattedPayload["diagnosis_HCC"] = tempHccDiagnosisValue
        }
      }
      if (Object.keys(formattedPayload)?.includes("tumorDetails_HeadAndNeckCancer")) {
        const tempTumorDetailsValue: any = formattedPayload["tumorDetails_HeadAndNeckCancer"]
        if (tempTumorDetailsValue?.length > 0) {
          tempTumorDetailsValue?.forEach((eachTumor: any, index: any) => {
            const tempEachTumorValue: any = { ...eachTumor }
            const eachTumorKeys: any = Object.keys(tempEachTumorValue)
            const tumorLocationKey: any = eachTumorKeys?.find((each: any) => each?.includes("tumorLocationDesc_HeadAndNeckCancer"))
            const tumorLocationValue: any = tempEachTumorValue[tumorLocationKey]
            eachTumorKeys?.forEach((eachKey: any) => {
              if (!(eachKey === tumorLocationKey)) {
                if (tumorLocationValue === "NA") {
                  delete tempEachTumorValue[eachKey]
                }
              }
            })
            tempTumorDetailsValue[index] = tempEachTumorValue
          })
          formattedPayload["tumorDetails_HeadAndNeckCancer"] = tempTumorDetailsValue
        }
      }
      if (Object.keys(formattedPayload)?.includes("reason_Multiple_Myeloma")) {
        if (formattedPayload["eligibilityForAsct_Multiple_Myeloma"] !== false || !formattedPayload["eligibilityForAsct_Multiple_Myeloma"] && formattedPayload["eligibilityForAsct_Multiple_Myeloma"] !== false) {
          delete formattedPayload["reason_Multiple_Myeloma"]
        }
      }
      if (Object.keys(formattedPayload)?.includes("reason_Multiple_Myeloma-Comment")) {
        if (
          formattedPayload["eligibilityForAsct_Multiple_Myeloma"] !== false || (
            !formattedPayload["eligibilityForAsct_Multiple_Myeloma"] && formattedPayload["eligibilityForAsct_Multiple_Myeloma"] !== false
          ) ||
          formattedPayload["reason_Multiple_Myeloma"] !== "other" ||
          !formattedPayload["reason_Multiple_Myeloma"]
        ) {
          delete formattedPayload["reason_Multiple_Myeloma-Comment"]
        }
      }
      if (Object.keys(formattedPayload)?.includes("proteinElectrophoresisAndImmunofixationQuantitative_Multiple_Myeloma")) {
        const tempValue: any = formattedPayload["proteinElectrophoresisAndImmunofixationQuantitative_Multiple_Myeloma"]
        if (tempValue?.length > 0) {
          tempValue?.forEach((eachValue: any, index: any) => {
            const tempEachValue: any = { ...eachValue }
            const eachKeys: any = Object.keys(tempEachValue)
            eachKeys?.forEach((key: any) => {
              if (key === "mBandDate_Multiple_Myeloma" || key === "mBandResult_Multiple_Myeloma") {
                if (tempEachValue["mBand_Multiple_Myeloma"] !== "Present" || !tempEachValue["mBand_Multiple_Myeloma"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "IgGDate_Multiple_Myeloma" || key === "IgGResult_Multiple_Myeloma") {
                if (tempEachValue["igg_Multiple_Myeloma"] !== "Present" || !tempEachValue["igg_Multiple_Myeloma"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "IgMDate_Multiple_Myeloma" || key === "IgMResult_Multiple_Myeloma") {
                if (tempEachValue["igm_Multiple_Myeloma"] !== "Present" || !tempEachValue["igm_Multiple_Myeloma"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "IgADate_Multiple_Myeloma" || key === "IgAResult_Multiple_Myeloma") {
                if (tempEachValue["iga_Multiple_Myeloma"] !== "Present" || !tempEachValue["iga_Multiple_Myeloma"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "mBand_Multiple_Myeloma-Comment") {
                if (!tempEachValue["mBand_Multiple_Myeloma"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "igg_Multiple_Myeloma-Comment") {
                if (!tempEachValue["igg_Multiple_Myeloma"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "igm_Multiple_Myeloma-Comment") {
                if (!tempEachValue["igm_Multiple_Myeloma"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "iga_Multiple_Myeloma-Comment") {
                if (!tempEachValue["iga_Multiple_Myeloma"]) {
                  delete tempEachValue[key]
                }
              }
            })
            tempValue[index] = tempEachValue
          })
          formattedPayload["proteinElectrophoresisAndImmunofixationQuantitative_Multiple_Myeloma"] = tempValue
        }
      }
      if (Object.keys(formattedPayload)?.includes("methods_TesticularCancer-Comment")) {
        if (
          formattedPayload["fertilityPreservation_TesticularCancer"] !== "Applicable" ||
          !formattedPayload["fertilityPreservation_TesticularCancer"] ||
          formattedPayload["methods_TesticularCancer"] !== "other" ||
          !formattedPayload["methods_TesticularCancer"]
        ) {
          delete formattedPayload["methods_TesticularCancer-Comment"]
        }
      }
      if (Object.keys(formattedPayload)?.includes("investigation_Thyroid")) {
        const tempValue: any = formattedPayload["investigation_Thyroid"]
        if (tempValue?.length > 0) {
          tempValue?.forEach((eachValue: any, index: any) => {
            const tempEachValue: any = { ...eachValue }
            const eachKeys: any = Object.keys(tempEachValue)
            eachKeys?.forEach((key: any) => {
              if (key === "tshDate" || key === "tshTestFindings" || key === "tshUploadFile") {
                if (tempEachValue["tsh"] !== "Done" || !tempEachValue["tsh"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "tgDate" || key === "tgTestFindings" || key === "tgUploadFile") {
                if (tempEachValue["tg"] !== "Done" || !tempEachValue["tg"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "antiTgAntibodiesDate" || key === "antiTgAntibodiesTestFindings" || key === "antiTgAntibodiesUploadFile") {
                if (tempEachValue["antiTgAntibodies"] !== "Done" || !tempEachValue["antiTgAntibodies"]) {
                  delete tempEachValue[key]
                }
              } else if (key === "serumCalcitoninDate" || key === "serumCalcitoninTestFindings" || key === "serumCalcitoninUploadFile") {
                if (tempEachValue["serumCalcitonin"] !== "Done" || !tempEachValue["serumCalcitonin"]) {
                  delete tempEachValue[key]
                }
              }
            })
            tempValue[index] = tempEachValue
          })
          formattedPayload["investigation_Thyroid"] = tempValue
        }
      }
      if (Object.keys(formattedPayload)?.includes(clinicalStagingKey)) {
        const clinicalStagingValue = formattedPayload[clinicalStagingKey]
        if (Array.isArray(clinicalStagingValue) && clinicalStagingValue?.length > 0) {
          const filtered: any = clinicalStagingValue?.filter((each: any) => !(Object.keys(each)?.length === 1 && Object.keys(each)[0]?.toLowerCase()?.includes("stage")))
          if (filtered?.length > 0) {
            formattedPayload[clinicalStagingKey] = filtered
          } else {
            delete formattedPayload[clinicalStagingKey]
          }

        }
      }
      if (Object.keys(formattedPayload)?.includes(pathologicalStagingKey)) {
        const pathologicalStagingValue = formattedPayload[pathologicalStagingKey]
        if (Array.isArray(pathologicalStagingValue) && pathologicalStagingValue?.length > 0) {
          const filtered: any = pathologicalStagingValue?.filter((each: any) => !(Object.keys(each)?.length === 1 && Object.keys(each)[0]?.toLowerCase()?.includes("stage")))
          if (filtered?.length > 0) {
            formattedPayload[pathologicalStagingKey] = filtered
          } else {
            delete formattedPayload[pathologicalStagingKey]
          }
        }
      }
      return { ...formattedPayload }
    } else {
      return { ...dataObj };
    }
  };

  return (
    <div className="staging-diagnosis" id="staging-diagnosis">
      {isCompleted ? (
        <Toast
          textMessage="Staging data saved successfully"
          onCloseText={"Close"}
          onClose={() => {
            setIsCompleted(false);
            // setStagingData(savedStagingData)
            if (scroll) {
              scroll()
            }
          }}
          type="success"
        ></Toast>
      ) : isError ? (
        <Toast
          textMessage={message}
          onCloseText={"Close"}
          onClose={() => {
            setMessage("");
            setIsError(false);
            setStagingData(savedStagingData);
            updateInputValues(savedStagingData);
            if (scroll) {
              scroll()
            }
          }}
          type="error"
        ></Toast>
      ) : displayToast ? (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => toggleDisplayToast(false)}
          onCloseText="Close"
          onClickText={null}
        />
      ) : (
        ""
      )}
      <div id="heading-staging" className="heading-staging">
        Staging and Diagnosis
      </div>
      <div className="common-cancer-field">
        <div className="common-cancer-row">
          <div style={{ width: "4.5%" }} className="common-cancer-class">
            <label style={{ marginLeft: "-15px" }} title="Relapsed/Progression">
              R/P
            </label>
            {/* <label>Progression</label> */}
          </div>
          <div style={{ width: "19.5%" }} className="common-cancer-class">
            <label>Cancer Type:</label>
          </div>
          <div style={{ width: "20%" }} className="common-cancer-class">
            <label>Diagnosis:</label>
          </div>

          <div style={{ width: "21%" }} className="common-cancer-class">
            <label>*Diagnosis Date:</label>
          </div>
          <div style={{ width: "20%" }} className="common-cancer-class">
            <label>*ICD:</label>
          </div>
          <div className="common-cancer-class">
            <label></label>
          </div>
        </div>

        {stagingData?.map((each: any, index: any) => {
          return (
            <div className="staging-row">
              <div style={{ width: "5%", marginTop: "8px" }}>
                <input
                  type="checkbox"
                  checked={each?.relapseOrProgression}
                  onChange={(e: any) => {
                    const values = [...stagingData];
                    values[index]["relapseOrProgression"] = e?.target?.checked;
                    setStagingData(values);
                    updateInputValues(values);
                  }}
                  disabled={isReadOnly}
                />
              </div>

              <div className="react-custom-select" style={{ width: "30%" }}>
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  options={cancerType}
                  defaultValue={each?.cancerType}
                  onChange={(option: any) => {
                    const values = [...stagingData];
                    values[index] = {
                      relapseOrProgression: false,
                      cancerType: option?.label,
                      diagnosis: "",
                      diagnosisDate: "",
                      icd: "",
                      id: option?.value,
                      cancerTemplateId: option?.value,
                    };
                    setStagingData(values);
                    updateInputValues(values);
                  }}
                  value={cancerType.filter(
                    ({ label }) => label === each?.cancerType
                  )}
                  isDisabled={isReadOnly}
                />
              </div>
              <div style={{ width: "20%", marginRight: "5px" }}>
                <InputField
                  value={each?.diagnosis}
                  handleChange={(e: any) => {
                    const values = [...stagingData];
                    values[index]["diagnosis"] = e?.target?.value;
                    setStagingData(values);
                    updateInputValues(values);
                  }}
                  placeholder={"Diagnosis"}
                  readOnly={isReadOnly}
                ></InputField>
              </div>
              <div style={{ width: "20%" }}>
                <InputField
                  handleChange={(e) => {
                    const values = [...stagingData];
                    values[index]["diagnosisDate"] = e?.target?.value;
                    setStagingData(values);
                    updateInputValues(values);
                  }}
                  value={each?.diagnosisDate}
                  calendar={true}
                  max={moment(new Date()).format("YYYY-MM-DD")}
                  readOnly={isReadOnly}
                ></InputField>
              </div>
              <div className="react-custom-select icd-style" style={{ width: "20%" }}>
                <CreatableSelect
                  ref={icdRef}
                  className={`${isReadOnly ? 'readOnly' : ''}`}
                  isClearable
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  options={icdOptions[`${each?.cancerType}`]}
                  defaultValue={each?.icd}
                  onChange={(option: any) => {
                    if (option.label.includes("-")) {
                      const values = [...stagingData];
                      values[index]["icd"] = option?.label;
                      setStagingData(values);
                      updateInputValues(values);
                    } else if (inputICDValue[index] !== "") {
                      const temp = inputFullICDValue[index].split("-")
                      if (temp?.length > 0) {
                        const values = [...stagingData];
                        values[index]["icd"] = [temp[0].trimEnd(), inputICDValue[index]].join(" - ");
                        setStagingData(values);
                        updateInputValues(values);
                      }
                    }
                    if (icdRef.current) {
                      icdRef.current.blur()
                    }
                  }}
                  value={getIcdString(
                    icdOptions[`${each?.cancerType}`],
                    each?.icd
                  )}
                  inputValue={inputICDValue[index]}
                  onInputChange={(newValue: string) => {
                    if (newValue !== undefined) {
                      const IcdValue: any = [...inputICDValue]
                      IcdValue[index] = newValue
                      setInputICDValue(IcdValue);
                    } else {
                      const IcdValue: any = [...inputICDValue]
                      IcdValue[index] = ""
                      setInputICDValue(IcdValue);
                    }
                  }}
                  onFocus={(e: any) => {
                    if (!icdOptions[`${each?.cancerType}`].some((option: any) => option.label === each.icd && option.value === each.icd)) {
                      icdOptions[`${each?.cancerType}`].push({ label: each.icd, value: each.icd });
                    }

                    const fullValue: any = [...inputFullICDValue]
                    fullValue[index] = each.icd
                    setInputFullICDValue(fullValue);

                    const IcdValue: any = [...inputICDValue]
                    IcdValue[index] = each.icd.split(' - ')[1]
                    setInputICDValue(IcdValue);
                  }}
                  onBlur={(e: any) => {
                    if (icdRef.current) {
                      icdRef.current.blur()
                    }
                  }}
                  isDisabled={isReadOnly}
                />
                {/* <CreatableSelect
                  isClearable
                  value={
                    each?.icd
                      ? icdOptions[`${each?.cancerType}`]?.filter(
                        ({ label }: any) => label === each?.icd
                      )?.length > 0 ? getIcdString(
                        icdOptions[`${each?.cancerType}`],
                        icdOptions[`${each?.cancerType}`].filter(
                          ({ label }: any) => label === each?.icd
                        )
                      ) : getIcdString(
                        icdOptions[`${each?.cancerType}`],
                        { label: each?.icd, value: each?.icd }
                      )
                      : getIcdString(
                        icdOptions[`${each?.cancerType}`],
                        newICD
                      )
                  }
                  onChange={(option: any) => {
                    const values = [...stagingData];
                    values[index]["icd"] = option?.label;
                    setStagingData(values);
                    setNewICD(option)
                  }}
                  onFocus={(e: any) => {
                    console.log("stagingData onfocus", e)
                    // setInputICDValue(e)
                  }}
                  inputValue={inputICDValue}
                  onInputChange={(newValue: string) => {
                    if (newValue !== undefined) {
                      setInputICDValue(newValue)
                    } else {
                      setInputICDValue("")
                    }
                  }}
                  options={icdOptions[`${each?.cancerType}`]}
                  filterOption={(option: any, input: any) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                  // defaultValue={each?.icd}
                  isDisabled={isReadOnly}
                /> */}
              </div>
              <div
                style={{ width: "5%", marginLeft: "5px" }}
                className=" delete-icon"
              >
                {!isReadOnly && (
                  <div
                    onClick={() => {
                      handleDeleteRow(index, each?.cancerType);
                    }}
                  >
                    <img
                      style={{ height: "16px" }}
                      src="../../../../assets/images/delete-icon.svg"
                      alt=""
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
        {!isReadOnly && (
          <div className="comorbidities add-new mt-3">
            <div
              className="add-new-button-staging"
              onClick={() => { setStagingData([...stagingData, stagingDataObj]); setInputFullICDValue([...inputFullICDValue, ""]); setInputICDValue([...inputICDValue, ""]); }}
            >
              Add New
            </div>
          </div>
        )}
        <div className="row">
          <div>
            {Object.keys(template).length > 0 ? (
              <CancerTemplateComponent
                css={defaultSurveyConfig.defaultSurveyCSS}
                data={surveyData}
                json={template}
                updateFlag={updateCallback}
                onComplete={(survey: any) => {
                  // setIsLoading(true);
                  //Revert to original
                  setSavedStagingData([...stagingData]);
                  setStagingData([stagingDataObj]);
                  updateInputValues([stagingDataObj]);
                  setTemplate({});
                  // setSurveyData({})
                  setConcatCancerType([]);
                  if (
                    stagingData?.some((each) => {
                      if (!each?.diagnosisDate && !each?.icd) {
                        setMessage(
                          `Please select Diagnosis Date and ICD value for ${each?.cancerType} to proceed further.`
                        );
                      } else if (!each?.diagnosisDate) {
                        setMessage(
                          `Please select Diagnosis Date for ${each?.cancerType} to proceed further.`
                        );
                      } else if (!each?.icd) {
                        setMessage(
                          `Please select ICD value for ${each?.cancerType} to proceed further.`
                        );
                      }
                      return !each?.diagnosisDate || !each?.icd;
                    })
                  ) {
                    setIsError(true);
                  } else {
                    let formattedData = [...stagingData];
                    formattedData?.forEach((each: any) => delete each["id"]);
                    //Format data object to remove unwanted staging data
                    let formattedSurveyData: any = formatStagingData(survey, surveyData);
                    addCancerTemplateData(
                      formattedSurveyData,
                      formattedData,
                      patientId
                    )
                      .then((res: any) => {
                        setIsLoading(false);
                        setIsCompleted(true);
                        const temp = res?.diagnosis?.map((ele: any) => {
                          const obj = cancerType?.find(
                            (each: any) => each?.label === ele?.cancerType
                          );
                          return { ...ele, ...{ id: obj?.value } };
                        });
                        setStagingData(temp);
                        updateInputValues(temp);
                        setSurveyData(res?.staging);
                      })
                      .catch((err) => {
                        console.log(err);
                        setIsLoading(false);
                        setIsError(true);
                        setMessage("Something went wrong, please try again!!!");
                      });
                  }
                  /** Save to a database */
                  /** Add to a spreadsheet, etc.... */
                }}
                cancerType={concatCancerType}
                patientInfo={patientDetail}
                toggleDisplayToast={toggleDisplayToast}
                isReadOnly={isReadOnly}
              />
            ) : isLoading ? (
              <div className="d-flex justify-content-center mt-5">
                <div className="spinner-border text-secondary"></div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {
        <Modal size="xl" show={open} onHide={() => setOpen(false)}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>{content}</Modal.Body>
        </Modal>
      }
    </div>
  );
}
